/* Next10 — mantém o rótulo "Comprar" no botão de compra.
   O Dawn reescreve o texto do botão com window.variantStrings.addToCart
   sempre que a variante muda, então o valor precisa ser trocado antes disso. */
(function () {
  'use strict';
  if (window.variantStrings) window.variantStrings.addToCart = 'Comprar';
  if (window.accessibilityStrings && window.accessibilityStrings.addToCart) {
    window.accessibilityStrings.addToCart = 'Comprar';
  }
})();
